import { ProjectState } from "./state";
import { getStoreAccessors } from "typesafe-vuex";
import { State } from "../state";

export const getters = {
  adminProjects: (state: ProjectState) => state.projectList,
  top_project_scenes: (state: ProjectState) => state.top_project_scenes,
  myProjects: (state: ProjectState) => state.myProjects,
  projectScenes: (state: ProjectState) => state.projectSceneList,
  projectScenesPage: (state: ProjectState) => state.projectScenePage,
  projectSgameSkinList: (state: ProjectState) => state.projectSgameSkinList,
  projectUsers: (state: ProjectState) => state.projectUserList,
  projectDetail: (state: ProjectState) => state.project,
  reportStat: (state: ProjectState) => state.reportStat,
  visitStatistics: (state: ProjectState) => state.visitStatistics,
  visitStatTrend: (state: ProjectState) => state.visitStatTrend,
  visitMonitorTrend: (state: ProjectState) => state.monitorTrend,
  visitMonitorList: (state: ProjectState) => state.monitorlist,
  visitMonitorUploadList: (state: ProjectState) => state.monitorUploadList,
  topPerformance: (state: ProjectState) => state.topPerformance,
  topPerformanceList: (state: ProjectState) => state.topPerformanceList,
  topPerformanceListAdvance: (state: ProjectState) => state.topPerformanceListtAdvance,
  topPerformanceOld: (state: ProjectState) => state.topPerformanceOld,
  topProjectPerformance: (state: ProjectState) => state.topProjectPerformance,
  topOptions: (state: ProjectState) => state.topOptions,
  topLabelPerformance: (state: ProjectState) => state.topLabelPerformance,
  topMainLabelPerformance: (state: ProjectState) => state.topMainLabelPerformance,
  topModelPerformance: (state: ProjectState) => state.topModelPerformance,
  topLevelPerformance: (state: ProjectState) => state.topLevelPerformance,
  topTesterPerformance: (state: ProjectState) => state.topTesterPerformance,
  topCpuList: (state: ProjectState) => state.topCpuList,
  topProblemSummary: (state: ProjectState) => state.topProblemSummary,
  topSceneList: (state: ProjectState) => state.topSceneList,
  topProblemByCpu: (state: ProjectState) => state.topProblemByCpu,
  topSceneListVersion: (state: ProjectState) => state.topSceneListVersion,
  topModelList: (state: ProjectState) => state.topModelList,
  topModelListVersion: (state: ProjectState) => state.topModelListVersion,
  topVersionList: (state: ProjectState) => state.topVersionList,
  topVersionListVersion: (state: ProjectState) => state.topVersionListVersion,
  topVersionListProblem: (state: ProjectState) => state.topVersionListProblem,
  topProjectType: (state: ProjectState) => state.topProjectType,
  topVersionData: (state: ProjectState) => state.topVersionData,
  visitMonitorUploadTrend: (state: ProjectState) => state.monitorUploadTrend,
  testAppointment: (state: ProjectState) => state.testAppointment,
  GamesDate: (state: ProjectState) => state.GamesDate,
  GamesData: (state: ProjectState) => state.GamesData,
  hokIcon: (state: ProjectState) => state.hokIcon,
  hok_skin_versions: (state: ProjectState) => state.hok_skin_versions,
  hok_skin_devices: (state: ProjectState) => state.hok_skin_devices,
  hok_skin_data: (state: ProjectState) => state.hok_skin_data,
  hok_skin_data_page: (state: ProjectState) => state.hok_skin_data_page,
  hokIn: (state: ProjectState) => state.hokIn,
  HokInV1: (state: ProjectState) => state.HokInV1,
  hokIn_add: (state: ProjectState) => state.hokIn_add,
  hokIn_add_v1: (state: ProjectState) => state.hokIn_add_v1,
  hokOut_add: (state: ProjectState) => state.hokOut_add,
  hokOut_add_v1: (state: ProjectState) => state.hokOut_add_v1,
  hokOut: (state: ProjectState) => state.hokOut,
  hokOutV1: (state: ProjectState) => state.hokOutV1,
  hokDeviceList: (state: ProjectState) => state.hokDeviceList,
  hokDeviceOutList: (state: ProjectState) => state.hokDeviceOutList,
  modelList: (state: ProjectState) => state.modelList,
  modelOptions: (state: ProjectState) => state.modelOptions,
  hokInSkinTrend: (state: ProjectState) => state.hokInSkinTrend,
  hokOutSkinTrend: (state: ProjectState) => state.hokOutSkinTrend,
  testAppointmentAdamins: (state: ProjectState) => state.testAppointmentAdamins,
  testAppointmentTable: (state: ProjectState) => state.testAppointmentTable,
  testAppointmentTableAll: (state: ProjectState) => state.testAppointmentTableAll,
};

const { read } = getStoreAccessors<ProjectState, State>("");

export const readAdminProjects = read(getters.adminProjects);
export const readMyProjects = read(getters.myProjects);
export const readProjectScenes = read(getters.projectScenes);
export const readTopProjectScenes= read(getters.top_project_scenes);
export const readProjectScenesPage = read(getters.projectScenesPage);
export const readProjectSgameSkinList = read(getters.projectSgameSkinList);
export const readProjectUsers = read(getters.projectUsers);
export const readProjectDetail = read(getters.projectDetail);
export const readReportStat = read(getters.reportStat);
export const readVisitStatistics = read(getters.visitStatistics);
export const readVisitStatTrend = read(getters.visitStatTrend);
export const readMonitorTrend = read(getters.visitMonitorTrend);
export const readMonitorList = read(getters.visitMonitorList);
export const readMonitorUploadList = read(getters.visitMonitorUploadList);
export const readMonitorUploadTrend = read(getters.visitMonitorUploadTrend);
export const readtopPerformance = read(getters.topPerformance);
export const readtopPerformanceList = read(getters.topPerformanceList);
export const readtopPerformanceListAdvance = read(getters.topPerformanceListAdvance);
export const readtopPerformanceOld = read(getters.topPerformanceOld);
export const readtopProjectPerformance = read(getters.topProjectPerformance);
export const readtopProjectTopOptions = read(getters.topOptions);
export const readtopLabelPerformance = read(getters.topLabelPerformance);
export const readtopMainLabelPerformance= read(getters.topMainLabelPerformance);
export const readtopModelPerformance = read(getters.topModelPerformance);
export const readtopLevelPerformance = read(getters.topLevelPerformance);
export const readtopTesterPerformance = read(getters.topTesterPerformance);
export const readtopCpuList = read(getters.topCpuList);
export const readtopProblemSummary = read(getters.topProblemSummary);
export const readtopSceneList = read(getters.topSceneList);
export const readtopProblemByCpu = read(getters.topProblemByCpu);
export const readtopSceneListVersion = read(getters.topSceneListVersion);
export const readtopModelList = read(getters.topModelList);
export const readtopModelListVersion = read(getters.topModelListVersion);
export const readtopVersionList= read(getters.topVersionList);
export const readtopVersionListVersion= read(getters.topVersionListVersion);
export const readtopVersionListProblem= read(getters.topVersionListProblem);
export const readtopProjectType= read(getters.topProjectType);
export const readtopVersionData= read(getters.topVersionData);
export const readtestAppointment = read(getters.testAppointment);
export const readtestGamesDate= read(getters.GamesDate);
export const readtestGamesData= read(getters.GamesData);
export const readtesthokIcon= read(getters.hokIcon);
export const readtesthokSkinVersions= read(getters.hok_skin_versions);
export const readtesthokSkinDevices= read(getters.hok_skin_devices);
export const readtesthokSkinData= read(getters.hok_skin_data);
export const readtesthokSkinDataPage= read(getters.hok_skin_data_page);
export const readtesthokIn= read(getters.hokIn);
export const readtesthokInV1= read(getters.HokInV1);
export const readtesthokInAdd= read(getters.hokIn_add);
export const readtesthokInAddV1= read(getters.hokIn_add_v1);
export const readtesthokOutAdd= read(getters.hokOut_add);
export const readtesthokOutAddV1= read(getters.hokOut_add_v1);
export const readtesthokOut= read(getters.hokOut);
export const readtesthokOutV1= read(getters.hokOutV1);
export const readtestDeviceList= read(getters.hokDeviceList);
export const readtestDeviceOutList= read(getters.hokDeviceOutList);
export const readModelList= read(getters.modelList);
export const readModelOptions= read(getters.modelOptions);
export const readhokInSkinTrend= read(getters.hokInSkinTrend);
export const readhokOutSkinTrend= read(getters.hokOutSkinTrend);
export const readtestAppointmentAdamins = read(getters.testAppointmentAdamins);
export const readtestAppointmentTable = read(getters.testAppointmentTable);
export const readtestAppointmentTableAll = read(getters.testAppointmentTableAll);
